import cx from 'clsx'
import React from 'react'

import styles from './styles.module.scss'

export interface IImageProps {
  src: string
  fallbackSrc?: string
  type: 'cover' | 'contain'
  alt: string
  onClick?: () => void
  style?: React.CSSProperties
  icon?: boolean
  iconGradient?: boolean
  round?: boolean
  id?: string
  className?: string
  imgClassName?: string
}

/** @deprecated prefer next/image */
export const Image = ({
  className,
  src,
  fallbackSrc,
  type,
  alt,
  style = {},
  onClick,
  icon,
  round,
  iconGradient,
  id,
  imgClassName,
}: IImageProps) => {
  const classes = cx(
    styles.container,
    styles[type],
    {
      [styles.onClick]: onClick,
      [styles.icon]: icon,
      [styles.round]: round,
      [styles.iconGradient]: iconGradient,
    },
    className,
  )

  return (
    <div
      className={classes}
      style={style}
      onClick={() => (onClick ? onClick() : {})}
    >
      <img
        src={src}
        alt={alt}
        id={id}
        {...(fallbackSrc && {
          onError: ({ currentTarget }) => (currentTarget.src = fallbackSrc),
        })}
        className={imgClassName}
      />
    </div>
  )
}
